module.exports = __webpack_public_path__ + "static/img/hand_feel_002.bc371c57.png";